import { footerColumns } from '@/mocks/home';

export default function SiteFooter() {
  return (
    <footer id="footer" className="scroll-mt-28 bg-secondary-900 text-background-100">
      <div className="mx-auto max-w-shell px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-[1.3fr_2.7fr]">
          <div>
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-archive-2-line text-lg"></i>
              </span>
              <span className="font-heading text-lg font-bold tracking-tight text-background-50">
                黑料社网
              </span>
            </div>
            <p className="mt-4 max-w-xs font-body text-sm leading-7 text-background-300">
              一个专门做往期回顾与历史存档的站点。旧料也能挖，翻旧账更要有据可查——
              每一条都保留原始出处与收录时间。
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              {['往期回顾', '历史存档', '翻旧账'].map((word) => (
                <span
                  key={word}
                  className="rounded-full border border-background-50/20 px-3 py-1 font-label text-xs text-background-200"
                >
                  {word}
                </span>
              ))}
            </div>
          </div>

          <div className="grid grid-cols-2 gap-8 md:grid-cols-4">
            {footerColumns.map((column) => (
              <div key={column.title}>
                <h4 className="font-heading text-sm font-bold text-background-50">{column.title}</h4>
                <ul className="mt-4 space-y-2.5">
                  {column.links.map((link) => (
                    <li key={link.label}>
                      <a
                        href={link.href}
                        rel="nofollow"
                        className="cursor-pointer font-body text-sm text-background-300 transition-colors hover:text-accent-300"
                      >
                        {link.label}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-12 border-t border-background-50/15 pt-6">
          <p className="font-body text-xs leading-6 text-background-400">
            免责声明：本站为历史存档与往期内容整理栏目，所有条目均为公开信息的归档与回顾，仅供浏览参考，
            不构成任何事实认定。若涉及权利人异议，可通过页面底部入口提出，我们将按流程处理。
          </p>
          <div className="mt-5 flex flex-col items-start justify-between gap-3 sm:flex-row sm:items-center">
            <p className="font-label text-xs text-background-400">
              © 2016—2026 黑料社网 · 黑料社网历史存档 保留所有权利
            </p>
            <div className="flex flex-wrap items-center gap-x-5 gap-y-2 font-label text-xs text-background-400">
              <a href="#footer" rel="nofollow" className="cursor-pointer transition-colors hover:text-accent-300">
                收录标准
              </a>
              <a href="#footer" rel="nofollow" className="cursor-pointer transition-colors hover:text-accent-300">
                勘误与更正
              </a>
              <a href="#top" className="cursor-pointer transition-colors hover:text-accent-300">
                回到顶部
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}